module.exports = window.dnn.nodeModules.CommonComponents;